// extracted by mini-css-extract-plugin
export default {"mshop_logo_with_menu":"mshop_logo_with_menu__b2a0d44a","menu_icon":"menu_icon__b2a0d44a","shop_icon":"shop_icon__b2a0d44a","transparent":"transparent__b2a0d44a"};